module.exports = __webpack_public_path__ + "assets/img/414_main_img_carousel_2.c76b816f.png";